import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import {
    ComissaoAtividadeFiltroRequest,
    ComissaoAtividadePageResponse,
    ComissaoAtividadeResponsavelFiltroRequest,
    ComissaoAtividadeResponsavelResponse,
    ComissaoAtividadeResponse,
    ComissaoAtividadeSalvarRequest,
    ComissaoProximoCodigoAtividadeResponse,
    ComissaoSituacaoAtividadeResponse
} from '@/core/api/sicom-api/comissoes/atividades/comissao-atividade.model';
import { environment } from '@env/environment';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ComissaoAtividadeService extends BaseService {
    readonly PATH = environment.basePath + '/comissoes/atividades';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultarAtividades(request: ComissaoAtividadeFiltroRequest, page: number = 0, size: number = 200, context?: HttpContext): Observable<ComissaoAtividadePageResponse> {
        const params = new HttpParams().set('page', String(page)).set('size', String(size));
        return this.http.post<ComissaoAtividadePageResponse>(`${this.PATH}/consultar`, request, { params, context });
    }

    exportarAtividades(request: ComissaoAtividadeFiltroRequest, context?: HttpContext): Observable<Blob> {
        return this.http.post(`${this.PATH}/exportar`, request, { context, responseType: 'blob' });
    }

    excluirAtividade(idTarefa: number, context?: HttpContext): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/${idTarefa}`, { context });
    }

    listarResponsaveisAtividade(request: ComissaoAtividadeResponsavelFiltroRequest, context?: HttpContext): Observable<ComissaoAtividadeResponsavelResponse[]> {
        let params = new HttpParams();

        if (request.idReuniao !== undefined && request.idReuniao !== null) {
            params = params.set('idReuniao', String(request.idReuniao));
        }

        if (request.idEstruturaOrganizacional !== undefined && request.idEstruturaOrganizacional !== null) {
            params = params.set('idEstruturaOrganizacional', String(request.idEstruturaOrganizacional));
        }

        const nomeSolicitante = request.nmSolicitante?.trim();
        if (nomeSolicitante) {
            params = params.set('nmSolicitante', nomeSolicitante);
        }

        const ufSgUf = request.ufSgUf?.trim().toUpperCase();
        if (ufSgUf && ufSgUf !== 'BR') {
            params = params.set('ufSgUf', ufSgUf);
        }

        return this.http.get<ComissaoAtividadeResponsavelResponse[]>(`${this.PATH}/responsaveis`, { params, context });
    }

    listarSituacoesAtividade(context?: HttpContext): Observable<ComissaoSituacaoAtividadeResponse[]> {
        return this.http.get<ComissaoSituacaoAtividadeResponse[]>(`${this.PATH}/situacoes`, { context });
    }

    consultarProximoCodigoAtividade(context?: HttpContext): Observable<ComissaoProximoCodigoAtividadeResponse> {
        return this.http.get<ComissaoProximoCodigoAtividadeResponse>(`${this.PATH}/proximo-codigo`, { context });
    }

    cadastrarAtividade(request: ComissaoAtividadeSalvarRequest, context?: HttpContext): Observable<ComissaoAtividadeResponse> {
        return this.http.post<ComissaoAtividadeResponse>(this.PATH, request, { context });
    }

    atualizarAtividade(idTarefa: number, request: ComissaoAtividadeSalvarRequest, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/${idTarefa}`, request, { context });
    }
}
